<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="top-title-wrap">
                    <div class="main-title">
                        <span>{{ $t('Changelog') }}</span>
                    </div>

                    <router-link class="button primary ml-3" v-if="$auth.hasRole('admin')"
                                 :to="{ name: 'changelog.edit', params: { id: 'create' } }"> Create
                    </router-link>
                </div>
                <div class="changelog-items-wrap">
                  <div class="changelog-item" v-for="(changeLog,index) of changeLogs" :key="index">
                    <box>
                        <div class="">
                            <div class="top">
                                <div class="version">{{ changeLog.version }}</div>
                                <div class="date">{{ changeLog.date | humanDate }}</div>
                            </div>
                            <div class="release-name" v-if="changeLog.title!==''">{{ changeLog.title }}</div>
                            <div class="features-list" v-for="(item,indexItem) of changeLog.items" :key="indexItem">
                                <div class="label" v-if="item.title!=='' && item.title!=null">{{ item.title }}</div>
                                <p class="new-line">{{ item.text }}</p>
                              <div v-if="item.previewUrl" class="img-wrap">
                                <img :src="item.previewUrl" alt="">
                              </div>
                            </div>

                            <div v-if="$auth.hasRole('admin')">

                                <router-link class="button  mr-1" v-if="$auth.hasRole('admin')"
                                             :to="{ name: 'changelog.edit', params: { id: changeLog.id } }"> Edit
                                </router-link>
                                <dsp-button @click="$refs.deleteConfirmModal.show();deleteChangeLogId=changeLog.id">
                                    {{ $t('Delete') }}
                                </dsp-button>

                            </div>
                        </div>
                    </box>

                </div>
                </div>
            </div>
        </div>
        <dspConfirmModal
            ref="deleteConfirmModal"
            :message="$t('Do You want to delete change log?')"
            @confirm="onDeleteConfirm"
        />
    </div>
</template>

<script>


import moment from "moment";

export default {
    name: 'changelog',
    data: function () {
        return {
            changeLogs: [],
            deleteChangeLogId: null,
        }
    },
    filters: {
        humanDate: function (date) {
            return moment(date).format("MMM Do YY")
        }
    },
    watch: {},
    computed: {},
    created() {
        this.getData();
    },
    mounted: function () {

    },
    methods: {
        getData() {
            this.$axios.get('/changeLog').then(response => {

                this.changeLogs = response.data.data;

            });
        },
        onDeleteConfirm() {
            this.$notify.info('Removing...');

            this.axios.delete('/admin/changeLog/' + this.deleteChangeLogId).then(() => {

                this.$notify.info('Removed successfully!');
                this.getData();
            }).catch(() => {
                this.$notify.error(this.$t('Fail to remove'));
            }).finally(() => {
                this.deleteChangeLogId = null;
            });

            this.$refs.deleteConfirmModal.hide();
        },
    }

}
</script>

<style lang="scss" scoped>

.changelog-item {
    color: #212B36;

    .top {
        padding-top: 10px;
        padding-bottom: 20px;
        border-bottom: 1px solid #ECEDF1;

        .version {
            font-size: 21px;
            line-height: 28px;
        }

        .date {
            font-size: 11px;
            line-height: 20px;
            color: #1C2D3F;
        }
    }

    .release-name {
        font-weight: bold;
        padding-top: 20px;
        padding-bottom: 20px;
        font-size: 18px;
        line-height: 24px;
        border-bottom: 1px solid #ECEDF1;
    }

    .features-list {
        padding-top: 20px;
        padding-bottom: 10px;

        .label {
            padding: 8px 10px;
            font-size: 13px;
            line-height: 8px;
            color: #740B99;
            margin-bottom: 15px;
            border: 1px solid #740B99;
            border-radius: 100px;
            display: inline-block;
        }

        p {
            font-size: 12px;
            line-height: 20px;
            color: #1C2D3F;
        }
    }
}

.new-line {
    white-space: break-spaces;
}

.changelog-items-wrap {
  display: flex;
  flex-direction: column;
}

.img-wrap {
  max-width: 600px;
  height: 200px;
  position: relative;
  border-radius: 20px;
  overflow: hidden;
  img {
    width: 100%;
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
  }
}
</style>
